module.exports = __webpack_public_path__ + "img/banner.31f750c9.png";